export default "__VITE_ASSET__CkAZDjt___"